import {
  PermissionValues as Permissions,
  useCurrentAccount,
  useCurrentWorkspace,
} from '@gripp/shared-logic';
import { AddButton } from '../../shared/components/addButton/addButton';
import { useCampaignsCreation } from './campaignsCreationContext';

export const CampaignsToolbar = () => {
  const workspace = useCurrentWorkspace();
  const { account } = useCurrentAccount();
  const creation = useCampaignsCreation();

  const canCreate = !!account?.hasPermission(Permissions.campaign.create);

  if (!workspace || !canCreate || !creation) return null;

  return <AddButton onPress={creation.openNew} />;
};
